// Normalize a user-entered external URL. Returns null for empty / "#".
// If the user forgot the scheme (e.g. "instagram.com/aimway"), prepend https://
// so it opens as an absolute external link (not relative to the current domain).
export function externalUrl(v) {
  if (!v || typeof v !== "string") return null;
  const t = v.trim();
  if (!t || t === "#") return null;
  if (/^(https?:|mailto:|tel:)/i.test(t)) return t;
  return `https://${t.replace(/^\/+/, "")}`;
}
